import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { FormattedData } from "./generic-autocomplete.component";
import { ClientService } from "@core/services/client.service";
import { SearchFormSimplifiedListDTO } from "src/app/modules/private/modules/client/models/search-form-dto";
import { map } from "rxjs/operators";
import { ServiceFindByFiltersDTO } from "@shared/models/service-dto";
import { ServiceBoschService } from "@core/services/service-bosch.service";
import { CarWorkshopService } from "@core/services/car-workshop.service";
import { BackofficeBoschService } from "@core/services/backoffice-bosch.service";

@Injectable({
  providedIn: "root"
})
export class GenericAutocompleteService implements IGenericAutocompleteService {
  allCountries: FormattedData[] = [];

  constructor(
    private clientService: ClientService,
    private serviceBoschService: ServiceBoschService,
    private carWorkshopService: CarWorkshopService,
    private backofficeService: BackofficeBoschService
  ) {}

  //example request without pagination
  getClientToAutocomplete(search: string): Observable<FormattedData[]> {
    const searchForm: SearchFormSimplifiedListDTO = {
      tradingName: search
    };

    return this.clientService.listAllWithFilters(searchForm).pipe(
      map((clients) =>
        clients.map((client) => ({
          value: client.id,
          label: client.tradingName
        }))
      )
    );
  }

  //example request with pagination
  getServiceToAutocomplete(search: string): Observable<FormattedData[]> {
    const searchForm: ServiceFindByFiltersDTO = {
      nameFilter: search
    };

    return this.serviceBoschService
      .findByFilters(searchForm, {
        pageIndex: 0,
        pageSize: 30,
        totalElements: 0
      })
      .pipe(
        map((servicePagination) => {
          return servicePagination.content.map((service) => ({
            value: service,
            label: `${service.serviceCode} - ${service.displayName}`
          }));
        })
      );
  }

  getNetworkToAutocomplete(
    search: string,
    concept: any
  ): Observable<FormattedData[]> {
    if (concept == null) {
      concept = "";
    }

    const searchForm: any = {
      name: search,
      concept
    };

    return this.carWorkshopService.getNetworkName(searchForm).pipe(
      map((networks) =>
        networks.map((network) => ({
          value: network.id,
          label: network.name
        }))
      )
    );
  }

  getCategoriesToAutocomplete(search: string): Observable<FormattedData[]> {
    const searchForm: any = {
      code: search
    };

    return this.carWorkshopService.getCategories(searchForm).pipe(
      map((categories) =>
        categories.map((category) => ({
          value: category.id,
          label: category.code
        }))
      )
    );
  }

  getBackofficeOperationToAutocomplete(
    search: string
  ): Observable<FormattedData[]> {
    return this.backofficeService
      .findByFilters({ name: search, userType: "OPERATION" })
      .pipe(
        map((bkos) =>
          bkos.map((bko) => ({
            value: bko.id,
            label: bko.name
          }))
        )
      );
  }
}

export interface IGenericAutocompleteService {
  getClientToAutocomplete: (search: string) => Observable<FormattedData[]>;
  getServiceToAutocomplete: (search: string) => Observable<FormattedData[]>;
  getNetworkToAutocomplete: (
    search: string,
    otherParam: any
  ) => Observable<FormattedData[]>;
  getCategoriesToAutocomplete: (search: string) => Observable<FormattedData[]>;
  getBackofficeOperationToAutocomplete: (
    search: string
  ) => Observable<FormattedData[]>;
}
